function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default {
  methods: {
    $_emitSelfEvent: function $_emitSelfEvent(event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.$_emitMapEvent(event, _objectSpread({
        control: this.control
      }, data));
    },

    /** Bind events for markers, popups and controls.
     * MapboxGL JS emits this events on popup or marker object,
     * so we treat them as 'self' events of these objects
     */
    $_bindSelfEvents: function $_bindSelfEvents(events, emitter) {
      var _this = this;

      Object.keys(this.$listeners).forEach(function (eventName) {
        if (events.includes(eventName)) {
          emitter.on(eventName, _this.$_emitSelfEvent);
        }
      });
    },
    $_unbindSelfEvents: function $_unbindSelfEvents(events, emitter) {
      var _this2 = this;

      if (events.length === 0) return;
      if (!emitter) return;
      events.forEach(function (eventName) {
        emitter.off(eventName, _this2.$_emitSelfEvent);
      });
    }
  }
};